import { getApiKey } from "../../utils/apiKey";
import React, { useEffect, useState } from "react";

import { apiCall_domainV2 } from "../api";
import { createGlobalStyle } from "styled-components";
import axios from "axios";
import Header from "../header";
import Spinner from "../Spinner/Spinner";
import QuestionItem from "./QuestionItem";

export default function FAQ() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const GlobalStyles = createGlobalStyle`body{
      background: #262626 !important;
    }`;
  const fetchData = () => {
    const headers = {
      Authorization: getApiKey(),
      "content-type": "application/json",
    };
    axios
      .get(`${apiCall_domainV2}/customer/market`, {
        headers,
      })
      .then((res) => {
        setData(res.data.faq);
        setLoading(false);
      });
  };
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div>
      <GlobalStyles />
      <div className="faqHeader">
        <Header
          showSearchBar={true}
          title={"سوالات متداول"}
          isDarkTheme={true}
        />
      </div>
      {loading ? (
        <Spinner />
      ) : (
        <div>
          {data.map((item) => (
            <QuestionItem item={item} />
          ))}
        </div>
      )}
    </div>
  );
}
